<form [formGroup]="form" [attr.autocomplete]="'off'">
  <div class="form-row no-margin-bottom">
    <mat-form-field appearance="outline">
      <mat-label>G4 Aftalenr</mat-label>
      <input matInput formControlName="okKundeAftaleNr" type="number" autofocus />
      <button class="btn-icon" (click)="onSearchClick()" [disabled]="!form.valid" matSuffix matTooltip="Søg">
        <mat-icon svgIcon="search"></mat-icon>
      </button>
      @if (serviceaftale) {
        <mat-hint class="red no-breakline">
          Der eksisterer allerede en serviceaftale for G4 kundeaftalen
          <a [routerLink]="['/aftale', okKundeAftaleNr.value]">
            <mat-icon class="blue" svgIcon="document"></mat-icon>
            se aftale
          </a>
        </mat-hint>
      }
    </mat-form-field>
  </div>
  @if (kunde) {
    <div class="form-row no-margin-top">
      <div class="customer-info align-center">
        <h3 class="detail-rows-header">Kunde</h3>
        <div class="detail-rows">
          <div class="detail-row">
            <div class="detail-row__lbl">Navn</div>
            <div class="detail-row__val">{{ kunde.anlaegsadresse?.name }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-row__lbl">Adresse</div>
            <div class="detail-row__val">{{ kunde.anlaegsadresse?.adressLine }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-row__lbl">Telefon</div>
            <div class="detail-row__val">{{ $safeNavigationMigration(kunde.anlaegsadresse?.phone) | dkPhoneNumber }}</div>
          </div>
          <div class="detail-row">
            <div class="detail-row__lbl">E-mail*</div>
            <div class="detail-row__val">{{ kunde.anlaegsadresse?.email }}</div>
          </div>
        </div>
      </div>
    </div>
    <small>
      * Hvis mail er forkert: Du kan rette mail på kunden i G4 og genindlæse
      <a (click)="reload.emit()">her</a>
      .
    </small>
  }
</form>
